import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  id: "ec-aaad40c4-2ee5-4bd5-84ea-4f4a6d3d3d14-__Layer_1",
  "enable-background": "new 0 0 72 72",
  height: "512",
  viewBox: "0 0 72 72",
  width: "512",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<g id=\"ec-684ee476-c61d-4bf7-a7e4-c6dffdd3ce99-__Layer_2_1_\"><g id=\"ec-56c0d5cb-5b68-4479-aff8-6bab0808897d-__Layer_1-2\"><g id=\"ec-3121047e-2eed-45fb-8745-633dfb225ad3-__format_align_right\"><path d=\"m63 15h-54c-1.7 0-3-1.3-3-3s1.3-3 3-3h54c1.7 0 3 1.3 3 3s-1.3 3-3 3z\"></path><path d=\"m63 31h-36c-1.7 0-3-1.3-3-3s1.3-3 3-3h36c1.7 0 3 1.3 3 3s-1.3 3-3 3z\"></path><path d=\"m63 47h-54c-1.7 0-3-1.3-3-3s1.3-3 3-3h54c1.7 0 3 1.3 3 3s-1.3 3-3 3z\"></path><path d=\"m63 63h-36c-1.7 0-3-1.3-3-3s1.3-3 3-3h36c1.7 0 3 1.3 3 3s-1.3 3-3 3z\"></path></g></g></g>", 1)
  ]))]))
}
export default { render: render }